/* eslint-disable */
const COMMA_SEPARATOR: string = ",";
const NUMBER_OF_DECIMAL_PLACES = 2;
export interface INumberFormatter {
  removeNonallowedChars(value: string): string;
  formatEditableValue(value: number | string): string;
  formatReadOnlyValue(value: number | string): string;
  formatStandardNumber(string: string): string;
  removeDecimals(value: string | undefined): string;
}

const generateMissingDecimals = (currentDecimalLength: number) => {
  let missingDecimals: string = "";
  for (let i = currentDecimalLength + 1; i <= NUMBER_OF_DECIMAL_PLACES; i++) {
    missingDecimals = `${missingDecimals}0`;
  }
  return missingDecimals;
};

const NumberFormatter = (): INumberFormatter => {
  const formatDecimals = (value: string) => {
    const valueParts = value.split(COMMA_SEPARATOR);
    const decimals = valueParts[1];

    if (decimals) {
      if (decimals.length > NUMBER_OF_DECIMAL_PLACES) {
        return `${valueParts[0]},${decimals.slice(
          0,
          NUMBER_OF_DECIMAL_PLACES
        )}`;
      } else if (decimals.length < NUMBER_OF_DECIMAL_PLACES) {
        return `${valueParts[0]},${decimals}${generateMissingDecimals(
          decimals.length
        )}`;
      }
      return value;
    }

    return `${value},${generateMissingDecimals(0)}`;
  };

  const formatWholeNumber = (value: string) => {
    const valueParts = value.split(COMMA_SEPARATOR);
    let wholeNumber = valueParts[0];
    const decimals = valueParts[1];
    wholeNumber = wholeNumber.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    if (decimals) {
      return `${wholeNumber},${decimals}`;
    }
    return wholeNumber;
  };

  const convertToCommaDecimalsFormat = (value: string) => {
    return value.replace(/\./gi, ",");
  };

  const convertToDotDecimalsFormat = (value: string) => {
    return value.replace(/\,/gi, ".");
  };

  return {
    formatEditableValue(value: number | string) {
      const valueString = value.toString();
      let formattedValue = convertToCommaDecimalsFormat(valueString);
      formattedValue = formatDecimals(formattedValue);
      return formattedValue;
    },

    formatReadOnlyValue(value: number | string | undefined) {
      if (!value && value !== 0) {
        return "";
      }
      const valueString = value.toString();
      let formattedValue = convertToCommaDecimalsFormat(valueString);
      formattedValue = formatDecimals(formattedValue);
      formattedValue = formatWholeNumber(formattedValue);
      return formattedValue;
    },

    formatStandardNumber(value: string) {
      const formattedValue = convertToDotDecimalsFormat(value);
      return formattedValue;
    },

    removeNonallowedChars(value: string) {
      let cleanedValue = value.replace(/[^\d,]/g, "");
      if (value.trim().startsWith("-")) {
        cleanedValue = "-" + cleanedValue;
      }

      return cleanedValue;
    },

    removeDecimals(value: string | undefined) {
      const valueString = value ? value.toString() : "";
      if (valueString?.includes(",")) {
        return valueString.slice(0, valueString.length - 1);
      }
      return valueString;
    }
  };
};

export default NumberFormatter;
